import { useMemo } from 'react';
import { usePreservationGridRowsQuery } from './usePreservationGridRowsQuery';

/** Work order yang semua titik berita acaranya sudah terbit (TTD lengkap). */
export function useIssuedBeritaAcaraWorkOrderIds(jwt: string | null) {
  const query = usePreservationGridRowsQuery(jwt);
  const issuedWorkOrderIds = useMemo(() => {
    const ids = new Set<string>();
    for (const row of query.data ?? []) {
      const woId = String(row.work_order_document_id ?? '').trim();
      if (woId && row.completion_status === 'all_completed') ids.add(woId);
    }
    return ids;
  }, [query.data]);
  return { ...query, issuedWorkOrderIds };
}
